import { render } from "./StageAndStep.vue?vue&type=template&id=76d34917"
import script from "./StageAndStep.vue?vue&type=script&lang=js"
export * from "./StageAndStep.vue?vue&type=script&lang=js"

import "./StageAndStep.vue?vue&type=style&index=0&id=76d34917&lang=css"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__